import React from "react";

/** Page heading wrapper used by routes whose content component doesn't render its own title. */
export default function Page({ title, description, children }) {
  return (
    <div>
      {title && (
        <div className="mb-4 md:mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-gray-900">{title}</h1>
          {description && <p className="mt-1 text-sm text-gray-600">{description}</p>}
        </div>
      )}
      {children}
    </div>
  );
}
